import { useEffect, useRef, useState } from "react";
import { ArrowRight, X } from "lucide-react";
import { trackAeoLondonConversion } from "@/lib/analytics";

const SESSION_KEY = "aeo-london-score-prompt-shown";

/** A small, dismissible score reminder shown once after a visitor reaches 60% depth. */
export default function AeoLondonScrollPrompt() {
  const [open, setOpen] = useState(false);
  const tracked = useRef(false);

  useEffect(() => {
    const update = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0 || window.scrollY / scrollableHeight < 0.6) return;
      if (sessionStorage.getItem(SESSION_KEY)) return;
      sessionStorage.setItem(SESSION_KEY, "true");
      setOpen(true);
      if (!tracked.current) {
        tracked.current = true;
        trackAeoLondonConversion({ action: "score_prompt_shown", placement: "scroll_60" });
      }
    };

    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  if (!open) return null;

  return (
    <aside className="fixed bottom-4 left-4 z-[110] w-[min(24rem,calc(100vw-2rem))] rounded-xl border border-[#FF8C00]/35 bg-[#101722] p-4 shadow-2xl" aria-label="Free score reminder">
      <button type="button" onClick={() => setOpen(false)} className="absolute right-2 top-2 inline-flex size-11 items-center justify-center rounded-lg text-slate-300 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-[#FF8C00]" aria-label="Dismiss score reminder">
        <X className="size-4" aria-hidden="true" />
      </button>
      <p className="pr-10 text-sm font-semibold text-white">Want a high-level AI visibility baseline?</p>
      <p className="mt-2 text-sm leading-relaxed text-slate-300">Start with the Free AI Visibility Score. No card needed.</p>
      <a href="/free-ai-growth-audit/" data-score-direct="true" className="mt-4 inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-[#ffad4d] underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-[#FF8C00]" onClick={() => trackAeoLondonConversion({ action: "score_click", placement: "scroll_60" })}>
        Check my AI visibility<ArrowRight className="size-4" aria-hidden="true" />
      </a>
    </aside>
  );
}
